// @flow
import compose from "recompose/compose"
import {assert} from "@swarm2/assert"
import {containers} from "@swarm2/core"

export default compose(
  containers.app.withAuth,
  containers.willReceiveProps(props => {
    const {isAuthed, isAllowed, location, history} = props
    if (props.isError) return {}
    const error = !isAuthed ? 401 : !isAllowed ? 403 : null
    if (error) {
      console.log(error + " unauthorized. redirect to root", {
        location,
        isAuthed,
        isAllowed,
      })
      assert(
        location.pathname !== "/",
        "route `/` has no permission? but thats where we redirect!",
      )
      history.push("/")
      return {}
    }
    return {}
  }),
)



// WEBPACK FOOTER //
// ./src/common/withAllowed.js